/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Only_One_Code_MessageInputs */

const en_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can only enter one invite code.`)
};

const ar_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك إدخال رمز دعوة واحد فقط.`)
};

const de_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst nur einen Einladungscode eingeben.`)
};

const es_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo puedes introducir un código de invitación.`)
};

const fr_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous ne pouvez saisir qu’un seul code d’invitation.`)
};

const it_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi inserire un solo codice invito.`)
};

const ja_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力できる招待コードは1つだけです。`)
};

const ko_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드는 하나만 입력할 수 있어요.`)
};

const pt_br_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você só pode inserir um código de convite.`)
};

const ru_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете ввести только один код приглашения.`)
};

const th_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกรอกรหัสเชิญได้เพียงหนึ่งรหัสเท่านั้น`)
};

const tr_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca bir davet kodu girebilirsin.`)
};

const zh_cn_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个人只能输入一组邀请码。`)
};

const zh_tw_only_one_code_message = /** @type {(inputs: Only_One_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每個人只能輸入一組邀請碼。`)
};

/**
* | output |
* | --- |
* | "You can only enter one invite code." |
*
* @param {Only_One_Code_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const only_one_code_message = /** @type {((inputs?: Only_One_Code_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Only_One_Code_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_only_one_code_message(inputs)
	if (locale === "ar") return ar_only_one_code_message(inputs)
	if (locale === "de") return de_only_one_code_message(inputs)
	if (locale === "es") return es_only_one_code_message(inputs)
	if (locale === "fr") return fr_only_one_code_message(inputs)
	if (locale === "it") return it_only_one_code_message(inputs)
	if (locale === "ja") return ja_only_one_code_message(inputs)
	if (locale === "ko") return ko_only_one_code_message(inputs)
	if (locale === "pt_br") return pt_br_only_one_code_message(inputs)
	if (locale === "ru") return ru_only_one_code_message(inputs)
	if (locale === "th") return th_only_one_code_message(inputs)
	if (locale === "tr") return tr_only_one_code_message(inputs)
	if (locale === "zh_cn") return zh_cn_only_one_code_message(inputs)
	return zh_tw_only_one_code_message(inputs)
});